import React from 'react';
import { Heading } from '../../../ui/heading';

interface WelcomeHeaderProps {
  userName: string;
  lastSessionTime?: string;
  avatar?: string;
}

export const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ 
  userName, 
  lastSessionTime,
  avatar 
}) => {
  return (
    <div className="flex items-center justify-between mb-8">
      <div>
        <Heading level={2} className="text-gray-900">
          Welcome back, {userName}!
        </Heading>
        <p className="text-gray-600 mt-1">
          Here's what has surfaced since your last session.
        </p>
      </div>
    </div>
  );
};